import { LiturgyItem } from "./types";

export const getComplineCanticleAntiphon = (): LiturgyItem[] => {
    return [
        {
            type: "chant",
            boldMode: "none",
            tone: "3a.4",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        firstHalf: [
                            {
                                syllables: [
                                    {
                                        text: "Pre",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "serve",
                                        notes: ["5", "7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us,",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["7", "6"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "while",
                                        notes: ["5", "6"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "wak",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ing;",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "guard",
                                        notes: ["6", "7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "us",
                                        notes: ["8"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "while",
                                        notes: ["7", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "sleep",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "ing:",
                                        notes: ["6"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "that",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "a",
                                        notes: ["6"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "wake",
                                        notes: ["8"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "may",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "watch",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: ["7"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Christ;",
                                        notes: ["6", "7"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "and",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "a",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "sleep",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "we",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "may",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "rest",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "in",
                                        notes: ["4", "3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "peace.",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        },
    ];
};
